import { 
    API_ENDPOINTS, 
    customToast, 
    FormInput, 
    replaceKeyWithValue, 
    route, 
    SelectOption, 
    Stepper, 
    StringHelpers, 
    useDisabledContext, 
    useLangContext, 
    useQueries, 
    Variants 
} from "carrier-fe";
import { ToshibaInstallationFormData } from "../../pages/installation/toshiba/journey";
import { UseFormReturn } from "../../types/journey";
import { ProductModule, QUERY_KEYS } from "../../util/Constants";
import { useEffect, useState } from "react";

type SelectKey = 'product_children';
type Selects = Record<SelectKey, SelectOption[]>;

function ToshibaStep3({
    form,
    loading
}: {
    form: UseFormReturn<ToshibaInstallationFormData, any>,
    loading?: boolean,
}) {
    const { setValues, store, errors } = form;
    const { crud, fields } = useLangContext();
    const { disabled } = useDisabledContext();
    const [selects, setSelects] = useState<Selects>({
        product_children: [],
    });

    const {
        data: selectOptions,
        error,
        isLoading,
        refetch,
        refetching
    } = useQueries<{ data: SelectOption[] }>([
        ...store?.product_parent_id ? [{
            key: QUERY_KEYS.PRODUCT_CHILDREN,
            config: {
                method: 'GET',
                url: route(
                    API_ENDPOINTS.GENERIC.SELECT.PRODUCT.CHILDREN,
                    { product_parent_id: store?.product_parent_id }
                ),
            },
        }] : [],
    ]);

    useEffect(() => {
        if (!store?.product_parent_id || refetching) return;

        refetch();
    }, [store?.product_parent_id]);

    useEffect(() => {
        if (!selectOptions) return

        setSelects((prev) => ({
            ...prev,
            product_children: selectOptions?.product_children?.data ?? []
        }))
    }, [selectOptions]);

    useEffect(() => {
        if (!error) return;

        Object.values(error).map((e) =>
            customToast({ 
                title: (e?.response?.data as any)?.message, 
                variant: Variants.Danger 
            })
        );
    }, [error]);

    const systemConfigurationLang = StringHelpers.lower(
        `${crud?.sub_titles?.system || 'system'} ${fields?.configuration || 'configuration'}`
    );

    return (
        <Stepper.Step
            loading={isLoading || loading}
            title={systemConfigurationLang}
        >
            <FormInput
                name='product_child_id'
                type='searchable-select'
                label={replaceKeyWithValue(
                    crud?.sub_titles?.select
                        || 'Please select a :field',
                    'field',
                    systemConfigurationLang
                )}
                disabled={disabled}
                options={selects.product_children}
                value={store?.product_child_id}
                onChange={(value) => {
                    if (typeof value !== 'string') return;

                    const resetProducts = store?.product_child_id !== value 
                    
                    setValues({
                        product_child_id: value,
                        products: resetProducts
                            ? Array.from({ length: 2 }, () => new ProductModule())
                            : store?.products
                    });
                }}
                errorMessages={errors?.product_child_id}
                clearable={false}
            />
        </Stepper.Step>
    )
};

export default ToshibaStep3;